import React from 'react';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useParams } from 'react-router-dom';
import { getCurrentDateTime } from '../../utils/basic';

const Download2Pdf = ({ reportData, autoDgSerialNum, reportType, statistics }) => {
    const { plate_uuid, rptuid, filename, serialnum } = useParams();
    const formattedDateTime = getCurrentDateTime();
    const generatePDF = () => {
        let doc = new jsPDF();
        doc.setFontSize(8);

        // Determine the document title text
        const documentTitle = autoDgSerialNum
            ? `DG Serial #: ${autoDgSerialNum}`
            : plate_uuid
                ? `Plate Uid: ${plate_uuid}`
                : rptuid && serialnum
                    ? `Serial # - Report Id: ${serialnum}-${rptuid}`
                    : rptuid
                        ? `Report Uid: ${rptuid}`
                        : "Report";

        if (documentTitle) {
            doc.text(documentTitle, 10, 10);
        }

        // Add the date on the next line
        doc.text(`Date: ${formattedDateTime}`, 10, 17);

        // Define table columns       
        //Report Type is undefined for fixd cols' reports - if its not passed - 
        if (reportType === undefined || reportType === "fixedCol") {
            const cols = ['Statistic', 'Specification', 'Observed Value', 'Pass/Fail'];
            const colWidths = [70, 70, 50, 40];

            // Create table rows from data
            const tableRows = reportData.map(row => {
                return [row?.Statistic, row?.Specification, row?.ObservedValue, row?.passfailValue];
            });

            // Add table to PDF
            doc.autoTable({
                startY: 20,
                head: [cols],
                body: tableRows,
                colWidths: colWidths,
                styles: {
                    fontSize: 8,
                },
                didParseCell: (data) => {
                    if (data.column.index === 3) {
                        if (data.cell.raw === 'Fail') {
                            data.cell.styles.fillColor = [255, 0, 0]; // Red
                        } else if (data.cell.raw === 'Pass') {
                            data.cell.styles.fillColor = [0, 166, 80]; // Green
                        }
                    }
                }
            });

            // For reports with many stats reportTYpe passed in as vaibaleCol - settings are all different
            //replicate and control analysis reports
        } else {
            if (reportType === "variableCol") {
                doc = new jsPDF({
                    orientation: 'landscape',
                    unit: 'pt',
                    format: [2300, 1131]
                });
                // Prepare table headers
                const headers = ['REPLICATE', '# WELLS'];
                statistics.forEach((stat) => {
                    headers.push(stat, ''); // 1 column for stat header, followed by empty for the metric headers
                });

                // Prepare sub headers
                const subHeaders = ['', ''];
                statistics.forEach(() => {
                    subHeaders.push('Mean', 'Stdev');
                });

                // Prepare table data
                const tableData = [];
                for (const replicate in reportData) {
                    const row = [replicate, reportData[replicate].wells];
                    statistics.forEach((stat) => {
                        row.push(
                            reportData[replicate].stats[stat]?.Mean || '',
                            reportData[replicate].stats[stat]?.Stdev || ''
                        );
                    });
                    tableData.push(row);
                }

                // Prepare dynamic column styles
                const columnStyles = {
                    0: { cellWidth: 70 }, // REPLICATE
                    1: { cellWidth: 70 }, // # WELLS
                };
                let colIndex = 2;
                statistics.forEach(() => {
                    columnStyles[colIndex++] = { cellWidth: 62 }; // Mean
                    columnStyles[colIndex++] = { cellWidth: 62 }; // Stdev
                });

                // Calculate the table width to center it
                const baseWidth = 70 + 70; // Width of REPLICATE and # WELLS columns
                const statsWidth = statistics.length * 124; // Each statistic has 2 columns (Mean and Stdev) with 62 width each
                const tableWidth = baseWidth + statsWidth;
                const pageWidth = doc.internal.pageSize.getWidth();
                const marginLeft = (pageWidth - tableWidth) / 2;


                // Create the table
                doc.autoTable({
                    head: [headers, subHeaders],
                    body: tableData,
                    startY: 60,
                    //  startX: 40,
                    margin: { left: marginLeft },
                    styles: { overflow: 'linebreak' }, // Increase font size
                    headStyles: { fillColor: [4, 147, 67], fontSize: 11 }, // Custom green color '#049343' and larger font size
                    bodyStyles: { fontSize: 12 }, // Increase font size for body
                    // styles: { overflow: 'linebreak' },
                    // theme: 'grid',
                    columnStyles: columnStyles,
                    // headStyles: { fillColor: [4, 147, 67] },
                    didDrawPage: function (data) {
                        // doc.text('Report', data.settings.margin.left, 20);
                        // Set text color
                        doc.setTextColor(4, 147, 67);
                        // Set font size
                        doc.setFontSize(20);
                        // Get the page width to center the text
                        const pageWidth = doc.internal.pageSize.getWidth();
                        // Center the text
                        doc.text(`File-Id: ${filename} - ${formattedDateTime}`, pageWidth / 2, 30, { align: 'center' });
                    },
                    pageBreak: 'auto',
                });
            }
            //  doc.save(`${filename}.pdf`);
        }

        // Save PDF
        saveReport(doc, autoDgSerialNum, plate_uuid, rptuid, filename, serialnum);
        // autoDgSerialNum ? doc.save(`${autoDgSerialNum}.pdf`) ? plate_uuid ? doc.save(`${plate_uuid}.pdf`) ? rptuid ? doc.save(`${rptuid}.pdf`) : doc.save('report.pdf');
    };

    async function saveReport(doc, autoDgSerialNum, plate_uuid, rptuid, filename, serialnum) {
        const baseFilename = 'report'


        // Determine a unique filename by prioritizing available identifiers
        const autoDgRpt = autoDgSerialNum || plate_uuid;
        const mfgRpt = serialnum && rptuid ? `${serialnum}-${rptuid}` : rptuid;
        const fallbackName = filename || baseFilename;
        const reportName = `${autoDgRpt || mfgRpt || fallbackName}.pdf`;
        // Save the document
        try {
            await doc.save(reportName);
        } catch (error) {
            console.error('Error saving report:', error);
        }
    }


    return (
        <button className="text-center p-1 border border-custom-green rounded-[8px] bg-custom-green
                 text-white  text-xs 
                                            font-semibold leading-snuguppercase tracking-wider" onClick={generatePDF}>
            <CloudDownloadIcon fontSize="small" /> PDF
        </button>
    );

};
export default Download2Pdf;
